(ns
  frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.pdf.view
  (:require
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.pdf :as esg]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view
    :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.chart.view :as chart-view]
   [potpuri.core :as potpuri]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]))

(defn overview-pages
  [report-data]
  (concat [(page/page
            (page/third-column-background)
            (page/page-title {:page-title (:holding-name report-data) :toc-item true})
            (column/columns-2-to-1
             {:stack [(card/card
                       "Portfolio summary"
                       (text-content/rich-content (->> report-data
                                                       :portfolio-summary-text
                                                       :rich-content)))]}
             {:margin [0 15 0 0]
              :stack  [(pdf-table/dynamic-stack (->> report-data
                                                     :overview
                                                     :figures
                                                     (pdf-table/limit-dynamic-stack)))
                       (text-content/optional-footer (->> report-data
                                                          :overview))]}))
           (page/page
            (page/third-column-background)
            (page/page-title {:page-title (:holding-name report-data)})
            (column/columns-2-to-1
             (text-content/rich-content (-> report-data
                                            :recent-development-text
                                            :rich-content))
             (card/card "Locations"
                        {:svg    (chart-view/geomap-svg "highcharts"
                                                        (potpuri/deep-merge
                                                         (-> report-data
                                                             :map-data
                                                             :figures)
                                                         {:chart {:width  500
                                                                  :height 320}}))
                         :width  (- page/page-width-one-third 46)
                         :height 150}
                        (text-content/optional-footer (-> report-data
                                                          :map-data)))))]
          (table/dynamic-table-pages {:page-title (:holding-name report-data)}
                                     "Basic information"
                                     (-> report-data
                                         :basic-information)
                                     {:partition-size 20
                                      :odd-color      (theme/color [:pdf :table :odd-color])
                                      :even-color     (theme/color [:pdf :table :even-color])
                                      :heading-color  (theme/color [:pdf :table
                                                                    :heading-color])})
          (table/dynamic-table-pages {:page-title (:holding-name report-data)}
                                     "Key financials and KPIs"
                                     (-> report-data
                                         :key-financials-and-kpis)
                                     {:odd-color     (theme/color [:pdf :table :odd-color])
                                      :even-color    (theme/color [:pdf :table :even-color])
                                      :heading-color (theme/color [:pdf :table
                                                                   :heading-color])})))

(defn hotel-pages
  [report-data]
  (overview-pages report-data))

(defn hotel-pages-property-esg
  [view-data]
  (concat (overview-pages view-data)
          (esg/esg-pages view-data)))

(defn hotel-pages-portfolio-esg
  [view-data]
  (concat (overview-pages view-data)
          (esg/portfolio-esg-pages view-data)))
